import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Snackbar,
  Tabs,
  Tab,
  Card,
  CardContent,
  Avatar,
  Container,
  Chip,
  Tooltip,
  Divider,
  TextField,           // <-- added
  InputAdornment,      // <-- added
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import NotificationsIcon from "@mui/icons-material/NotificationsActive";
import { changeTenantStatus } from "../../../../Services/ClintsApi";
import { getClientReports } from "../../../../Services/ReportsApi";
import { deleteFeatureFromTenant } from "../../../../Services/FeaturesApi";
import MuiAlert from "@mui/material/Alert";
import SendNotificationDialog from "./SendNotificationdialog";
import ShowClintNotification from "./ShowClintNotification";
import NonSubscriberSustomersTap from "../NonSubscriberSustomers/NonSubscriberSustomersTap";
import { getPlane } from "../../../../Services/plansApi";
import PeopleIcon from "@mui/icons-material/People";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import PersonIcon from "@mui/icons-material/Person";
import LanguageIcon from "@mui/icons-material/Language";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EventIcon from "@mui/icons-material/Event";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";
import SearchIcon from "@mui/icons-material/Search"; // <-- added
import ClearIcon from "@mui/icons-material/Clear";   // <-- added
import GetAppIcon from "@mui/icons-material/GetApp"; // <-- new import for export button
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'; // <-- new icon import
import NewVersionRequestTap from "../CustomerNewVersionRequests/NewVersionRequestTap"; // <-- new component import

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CustomerPageMain = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewCustomer, setViewCustomer] = useState(null);
  const [addFeatureDialog, setAddFeatureDialog] = useState({
    open: false,
    tenant_id: null,
    features: [],
  });
  const [attachDialogOpen, setAttachDialogOpen] = useState(false);
  const [selectedTenantId, setSelectedTenantId] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState({
    open: false,
    tenantId: null,
    featureId: null,
    featureName: "",
  });
  const [notifMsg, setNotifMsg] = useState("");
  const [notifError, setNotifError] = useState("");
  const [notifDialog, setNotifDialog] = useState({
    open: false,
    tenant: null,
  });
  const [showNotificationsDialog, setShowNotificationsDialog] = useState({
    open: false,
    tenant: null,
  });
  const [activateDialog, setActivateDialog] = useState({
    open: false,
    tenantId: null,
    customerId: null,
    key: null,
  });
  const [activating, setActivating] = useState([]); // قائمة المفاتيح التي يتم تفعيلها حالياً

  // حالة تحميل خاصة بتفعيل حسابات المستخدمين (by user id)
  const [activatingUsers, setActivatingUsers] = useState([]);

  // حالات لفتح مكون CreateTanent
  const [createTenantOpen, setCreateTenantOpen] = useState(false);
  const [createTenantCustomer, setCreateTenantCustomer] = useState(null);

  // حالة تأكيد إيقاف/تشغيل النسخة
  const [tenantStatusDialog, setTenantStatusDialog] = useState({
    open: false,
    tenantId: null,
    tenantName: "",
    action: "stop", // "stop" or "start"
  });

  // حالة التبويب النشط
  const [activeTab, setActiveTab] = useState(0);
  const [planesMap, setPlanesMap] = useState({});
  const [expandedDomains, setExpandedDomains] = useState({});
  const [expandedEmails, setExpandedEmails] = useState({}); // تتبع البريد الإلكتروني الموسع
  const [searchQuery, setSearchQuery] = useState(""); // <-- جديد

  // جلب العملاء
  const fetchCustomers = () => {
  setLoading(true);
  getClientReports()
    .then((res) => {
      setCustomers(res.data?.data || []); // ✔ الآن تعمل .filter بدون مشاكل
    })
    .catch(() => setCustomers([]))
    .finally(() => setLoading(false));
};

useEffect(() => {
  fetchCustomers();
  fetchPlanes();
}, []);


  // تحديث بيانات العميل المعروض في الديالوج بعد إضافة ميزة جديدة
  const updateViewCustomer = (tenant_id, updatedFeatures) => {
    setViewCustomer((prev) => {
      if (!prev || !prev.tenant || prev.tenant.id !== tenant_id) return prev;
      return {
        ...prev,
        tenant: {
          ...prev.tenant,
          features: updatedFeatures,
        },
      };
    });
  };

  // فتح رسالة التأكيد
  const handleRemoveFeature = (tenantId, featureId, featureName) => {
    setConfirmDelete({
      open: true,
      tenantId,
      featureId,
      featureName,
    });
  };

  // تنفيذ الحذف بعد التأكيد
  const confirmDeleteFeature = async () => {
    try {
      await deleteFeatureFromTenant(
        confirmDelete.tenantId,
        confirmDelete.featureId
      );
      setConfirmDelete({ open: false, tenantId: null, featureId: null });
      await fetchCustomers();
      // تحديث بيانات العميل المعروض إذا كان هو نفسه الذي تم التعديل عليه
      if (
        confirmDelete.tenantId &&
        viewCustomer &&
        viewCustomer.tenant &&
        viewCustomer.tenant.id === confirmDelete.tenantId
      ) {
        const updated = customers.find(
          (c) => c.tenant && c.tenant.id === confirmDelete.tenantId
        );
        if (updated && updated.tenant) {
          updateViewCustomer(
            confirmDelete.tenantId,
            updated.tenant.features || []
          );
        }
      }
    } catch (err) {
      alert("حدث خطأ أثناء حذف الفيتشر");
      setConfirmDelete({ open: false, tenantId: null, featureId: null });
    }
  };

  // دالة فتح نافذة إرسال التنبيه
  const handleOpenNotifDialog = (customer) => {
    setNotifDialog({
      open: true,
      tenant: customer.tenant?.id || "",
    });
  };

  // تعديل onSuccess في SendNotificationDialog لعرض رسالة نجاح واخفائها بعد 3 ثواني
  const handleNotifSuccess = () => {
    setNotifDialog({ open: false, tenant: null });
    setNotifMsg("تم إرسال التنبيه بنجاح");
    setTimeout(() => setNotifMsg(""), 2000);
  };

  // دالة تغيير حالة النسخة (إيقاف/تشغيل) - فتح حوار التأكيد
  const handleChangeTenantStatus = (tenant, action) => {
    const tenantName = tenant.tenancy_db_name || `Tenant ${tenant.id}`;
    setTenantStatusDialog({
      open: true,
      tenantId: tenant.id,
      tenantName: tenantName,
      action: action,
    });
  };

  // تنفيذ تغيير حالة النسخة بعد التأكيد
  const confirmChangeTenantStatus = async () => {
    try {
      await changeTenantStatus(tenantStatusDialog.tenantId);
      const successMsg =
        tenantStatusDialog.action === "stop"
          ? "تم إيقاف النسخة بنجاح"
          : "تم تشغيل النسخة بنجاح";
      setNotifMsg(successMsg);
      await fetchCustomers();
      setTenantStatusDialog({
        open: false,
        tenantId: null,
        tenantName: "",
        action: "stop",
      });
    } catch (err) {
      const message =
        err?.response?.data?.message ||
        err?.message ||
        (tenantStatusDialog.action === "stop"
          ? "فشل إيقاف النسخة"
          : "فشل تشغيل النسخة");
      setNotifError(message);
      setTenantStatusDialog({
        open: false,
        tenantId: null,
        tenantName: "",
        action: "stop",
      });
    } finally {
      setTimeout(() => setNotifMsg(""), 3000);
      setTimeout(() => setNotifError(""), 3000);
    }
  };

  // تنفيذ التفعيل باستخدام tenantId أو customerId من حالة الـ dialog
  const performActivateCopy = async () => {
    const { tenantId, customerId, key } = activateDialog;
    if (!tenantId && !customerId) return;

    // نستخدم endpoint عام؛ سيرفرك يمكنه التمييز حسب الحقول المرسلة
    const url = `/api/tenants/activate-copy`;

    setActivating((prev) => [...prev, key]);
    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          tenant_id: tenantId || null,
          customer_id: customerId || null,
        }),
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || "فشل تفعيل النسخة");
      }
      setNotifMsg("تم تفعيل النسخة بنجاح");
      await fetchCustomers();
    } catch (err) {
      setNotifError(
        typeof err === "string"
          ? err
          : err?.message || "حدث خطأ عند تفعيل النسخة"
      );
    } finally {
      setActivating((prev) => prev.filter((k) => k !== key));
      setActivateDialog({
        open: false,
        tenantId: null,
        customerId: null,
        key: null,
      });
      setTimeout(() => setNotifMsg(""), 3000);
      setTimeout(() => setNotifError(""), 3000);
    }
  };

  // يفتح حوار التأكيد: يعطى الـ customer الكامل حتى نميز وجود tenant أم لا
  const openActivateDialog = (customer) => {
    if (!customer) return;
    const tenantId = customer.tenant?.id || null;
    const customerId = tenantId ? null : customer.id;
    const key = tenantId ? `t:${tenantId}` : `c:${customerId}`;
    setActivateDialog({ open: true, tenantId, customerId, key });
  };

  // فتح Dialog لمكون CreateTanent لعمل نسخة للعميل (المستخدم يضغط الزر حين لا يوجد tenant)
  const openCreateTenant = (customer) => {
    if (!customer) return;
    setCreateTenantCustomer(customer);
    setCreateTenantOpen(true);
  };

  // يغلق حوار التفعيل بدون تنفيذ
  const cancelActivate = () => {
    setActivateDialog({
      open: false,
      tenantId: null,
      customerId: null,
      key: null,
    });
  };

  // تفعيل الحساب يدوياً عبر API

  // تغيير التبويب النشط
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // تصفية العملاء بناءً على التبويب النشط وفلتر البحث
  const getFilteredCustomers = () => {
    const list = Array.isArray(customers) ? customers : [];
    const base = activeTab === 0 ? list.filter((c) => c.tenant) : list.filter((c) => !c.tenant);
    const q = (searchQuery || "").toLowerCase().trim();
    if (!q) return base;

    return base.filter((c) => {
      const name = (c.name || "").toLowerCase();
      const email = (c.email || "").toLowerCase();
      const phone = (c.phone || "").toLowerCase();
      const domain = (c.tenant?.domains?.[0]?.domain || "").toLowerCase();
      const brokerName = (c.broker?.name || "").toLowerCase();
      const planeName = c.tenant?.plane_id ? ((planesMap[c.tenant.plane_id] || String(c.tenant.plane_id)).toLowerCase()) : "";

      return (
        name.includes(q) ||
        email.includes(q) ||
        phone.includes(q) ||
        domain.includes(q) ||
        brokerName.includes(q) ||
        planeName.includes(q)
      );
    });
  };

  const filteredCustomers = getFilteredCustomers();

  const handleClearSearch = () => setSearchQuery("");

  const fetchPlanes = async () => {
    try {
      const res = await getPlane();
      const planes = res.data?.data?.palnes || [];
      const map = {};
      planes.forEach((p) => {
        if (p && p.id) map[p.id] = p.plane_name;
      });
      setPlanesMap(map);
    } catch (err) {
      console.error("Failed to fetch planes:", err);
      setPlanesMap({});
    }
  };

  // دالة لاختصار البريد الإلكتروني (عرض ما قبل @ فقط)
  const getShortEmail = (email) => {
    if (!email) return "";
    const atIndex = email.indexOf("@");
    return atIndex > 0 ? email.substring(0, atIndex) : email;
  };

  // دالة للتبديل بين عرض البريد الكامل والمختصر
  const toggleEmail = (customerId) => {
    setExpandedEmails((prev) => ({
      ...prev,
      [customerId]: !prev[customerId],
    }));
  };

  // دالة لاختصار الدومين (عرض الـ subdomain فقط)
  const getShortDomain = (domain) => {
    if (!domain) return "-";
    // استخراج subdomain فقط (كل شيء قبل النقطة الأولى)
    const parts = domain.split(".");
    return parts[0]; // يرجع فقط subdomain
  };

  // دالة للتبديل بين عرض الدومين الكامل والمختصر
  const toggleDomain = (customerId) => {
    setExpandedDomains((prev) => ({
      ...prev,
      [customerId]: !prev[customerId],
    }));
  };

  // دالة تصدير البيانات كـ CSV (يفتح في Excel)
	const exportToCSV = () => {
		const rows = filteredCustomers || [];
		if (!rows.length) {
			alert("لا توجد بيانات للتصدير");
			return;
		}

		const headers = [
			"ID",
			"الاسم",
			"البريد الإلكتروني",
			"الهاتف",
			"الموزع - الاسم",
			"الموزع - البريد",
			"الموزع - الهاتف",
			"الدومين",
			"الخطة",
			"تاريخ البداية",
			"تاريخ النهاية",
			"حالة النسخة",
			"تجريبي",
			"حالة الحساب"
		];

		const escape = (value) => {
			if (value === null || value === undefined) return "";
			const s = String(value);
			// escape quotes
			return `"${s.replace(/"/g, '""')}"`;
		};

		const lines = rows.map((c) => {
			const brokerName = c.broker?.name || "";
			const brokerEmail = c.broker?.email || "";
			const brokerPhone = c.broker?.phone || "";
			const domain = c.tenant?.domains?.[0]?.domain || "";
			const plane = c.tenant?.plane_id ? (planesMap[c.tenant.plane_id] || `#${c.tenant.plane_id}`) : "";
			const startDate = c.tenant?.start_date || "";
			const endDate = c.tenant?.end_date || "";
			const copyStatus = c.system_status === 1 ? "تعمل" : c.system_status === 0 ? "متوقفة" : "";
			const isDemo = c.tenant?.is_demo === 1 ? "نعم" : "لا";
			const accountStatus = c.active === 1 ? "نشط" : "غير نشط";

			return [
				escape(c.id),
				escape(c.name),
				escape(c.email),
				escape(c.phone),
				escape(brokerName),
				escape(brokerEmail),
				escape(brokerPhone),
				escape(domain),
				escape(plane),
				escape(startDate),
				escape(endDate),
				escape(copyStatus),
				escape(isDemo),
				escape(accountStatus)
			].join(",");
		});

		const csvContent = "\uFEFF" + headers.join(",") + "\n" + lines.join("\n"); // BOM للأوفيس
		const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
		const url = URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		const date = new Date().toISOString().slice(0,10);
		a.download = `customers_export_${date}.csv`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	};

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Card
        elevation={3}
        sx={{
          mb: 3,
          background:
            "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar
                sx={{
                  bgcolor: "white",
                  color: "#667eea",
                  width: 50,
                  height: 50,
                }}
              >
                <PeopleIcon sx={{ fontSize: 32 }} />
              </Avatar>
              <Box>
                <Typography
                  variant="h4"
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  إدارة العملاء
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ color: "rgba(255,255,255,0.9)" }}
                >
                  إدارة العملاء المشتركين وغير المشتركين
                </Typography>
              </Box>
            </Box>
            <Chip
              label={`${customers.length} عميل`}
              sx={{
                bgcolor: "white",
                color: "#667eea",
                fontWeight: "bold",
                fontSize: "1rem",
                px: 2,
                py: 3,
              }}
            />
          </Box>
        </CardContent>
      </Card>

      {/* التبويبات */}
      <Card elevation={3} sx={{ borderRadius: 2, mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            bgcolor: "#f5f5f5",
            "& .MuiTab-root": {
              fontSize: "1rem",
              fontWeight: "bold",
              minHeight: 72,
              transition: "all 0.3s",
              "&:hover": {
                bgcolor: "#e3f2fd",
              },
              "&.Mui-selected": {
                bgcolor: "white",
                color: "#1976d2",
              },
            },
          }}
        >
          <Tab
            label={
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <PeopleIcon />
                عملاء لديهم نسخة
                <Chip
                  label={customers.filter((c) => c.tenant).length}
                  size="small"
                  color="primary"
                />
              </Box>
            }
          />
          <Tab
            label={
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1 }}
              >
                <PersonOffIcon />
                عملاء بدون باقة
                <Chip
                  label={customers.filter((c) => !c.tenant).length}
                  size="small"
                  color="secondary"
                />
              </Box>
            }
          />
          <Tab
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <RequestQuoteIcon />
                طلبات العملاء الجدد
                {/* optional count Chip can be added if you expose requests count */}
              </Box>
            }
          />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {/* شريط البحث + زر التصدير يظهران فقط في تاب "عملاء لديهم نسخة" */}
          {activeTab === 0 && (
            <Card variant="outlined" sx={{ mb: 2, bgcolor: '#f8f9fa', border: '1px solid #e3f2fd' }}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <TextField
                    fullWidth
                    placeholder="ابحث بالاسم، البريد، الهاتف، الدومين، اسم الموزع، أو الخطة..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon color="action" />
                        </InputAdornment>
                      ),
                      endAdornment: searchQuery ? (
                        <InputAdornment position="end">
                          <IconButton size="small" onClick={handleClearSearch}>
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </InputAdornment>
                      ) : null,
                    }}
                  />
                  {/* زر التصدير */}
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<GetAppIcon />}
                    onClick={exportToCSV}
                    sx={{ whiteSpace: 'nowrap' }}
                  >
                    تصدير Excel
                  </Button>

                  <Chip label={`${filteredCustomers.length} نتيجة`} color="primary" />
                </Box>
              </CardContent>
            </Card>
          )}

          {activeTab === 0 ? (
             loading ? (
               <Box
                 sx={{
                   display: "flex",
                   justifyContent: "center",
                   alignItems: "center",
                   py: 8,
                 }}
               >
                 <CircularProgress size={60} />
                 <Typography variant="h6" sx={{ ml: 2 }}>
                   جاري تحميل البيانات...
                 </Typography>
               </Box>
             ) : filteredCustomers.length > 0 ? (
               <TableContainer
                 component={Paper}
                 elevation={0}
                 sx={{
                   borderRadius: 2,
                   border: "1px solid #e0e0e0",
                 }}
               >
                 <Table>
                   <TableHead>
                     <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         الاسم
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         البريد الإلكتروني
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         رقم الهاتف
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         الموزع
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         الدومين
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         حالة النسخة
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         تجريبية
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         الخطة
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         تاريخ البداية
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         تاريخ النهاية
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         حالة الحساب
                       </TableCell>
                       <TableCell sx={{ fontWeight: "bold", fontSize: "1rem" }}>
                         إجراءات
                       </TableCell>
                     </TableRow>
                   </TableHead>
                   <TableBody>
                     {filteredCustomers.map((customer) => {
                       const fullDomain = customer.tenant?.domains?.[0]?.domain;
                       const isDomainExpanded = expandedDomains[customer.id];
                       const fullEmail = customer.email;
                       const isEmailExpanded = expandedEmails[customer.id];

                       return (
                         <TableRow
                           key={customer.id}
                           sx={{
                             "&:hover": {
                               bgcolor:
                                 customer.system_status === 1
                                   ? "#e8f5e9"
                                   : "#fff3e0",
                               transition: "all 0.2s",
                           },
                           bgcolor:
                             customer.system_status === 1 ? "transparent" : "#fffde7",
                         }}
                        >
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <Avatar
                                sx={{
                                  bgcolor:
                                    customer.active === 1
                                      ? "#4caf50"
                                      : "#ff9800",
                                  width: 32,
                                  height: 32,
                                }}
                              >
                                <PersonIcon fontSize="small" />
                              </Avatar>
                              <Typography sx={{ fontWeight: "bold" }}>
                                {customer.name}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Tooltip title={isEmailExpanded ? "اختصار البريد" : "عرض البريد الكامل"}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                  cursor: 'pointer',
                                }}
                                onClick={() => toggleEmail(customer.id)}
                              >
                                <EmailIcon sx={{ color: "#666", fontSize: 18 }} />
                                <Typography 
                                  variant="body2"
                                  sx={{
                                    transition: 'all 0.3s',
                                    '&:hover': {
                                      color: '#1976d2',
                                      fontWeight: 'bold'
                                    }
                                  }}
                                >
                                  {isEmailExpanded ? fullEmail : getShortEmail(fullEmail)}
                                </Typography>
                              </Box>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <PhoneIcon sx={{ color: "#666", fontSize: 18 }} />
                              <Chip
                                label={customer.phone}
                                size="small"
                                variant="outlined"
                              />
                            </Box>
                          </TableCell>
                          
                          {/* عمود الموزع */}
                          <TableCell>
                            {customer.broker ? (
                              <Tooltip title={
                                <Box>
                                  <Typography variant="caption" sx={{ display: 'block' }}>
                                    <b>البريد:</b> {customer.broker.email}
                                  </Typography>
                                  <Typography variant="caption" sx={{ display: 'block' }}>
                                    <b>الهاتف:</b> {customer.broker.phone}
                                  </Typography>
                                </Box>
                              }>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 0.5,
                                  }}
                                >
                                  <Avatar
                                    sx={{
                                      bgcolor: "#9c27b0",
                                      width: 28,
                                      height: 28,
                                    }}
                                  >
                                    <BusinessIcon fontSize="small" />
                                  </Avatar>
                                  <Box>
                                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                                      {customer.broker.name}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                      ID: {customer.broker.id}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Tooltip>
                            ) : (
                              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                <BusinessIcon sx={{ color: "#999", fontSize: 18 }} />
                                <Typography variant="body2" color="text.secondary">
                                  لا يوجد
                                </Typography>
                              </Box>
                            )}
                          </TableCell>

                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <LanguageIcon sx={{ color: "#666", fontSize: 18 }} />
                              {fullDomain ? (
                                <Tooltip
                                  title={
                                    isDomainExpanded
                                      ? "اختصار الدومين"
                                      : "عرض الدومين الكامل"
                                  }
                                >
                                  <Chip
                                    label={
                                      isDomainExpanded
                                        ? fullDomain
                                        : getShortDomain(fullDomain)
                                    }
                                    size="small"
                                    color="info"
                                    onClick={() => toggleDomain(customer.id)}
                                    sx={{
                                      cursor: "pointer",
                                      transition: "all 0.3s",
                                      "&:hover": {
                                        transform: "scale(1.05)",
                                        boxShadow: 2,
                                      },
                                    }}
                                  />
                                </Tooltip>
                              ) : (
                                <Chip label="-" size="small" color="default" />
                              )}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Chip
                              icon={
                                customer.system_status === 1 ? (
                                  <PlayCircleFilledIcon />
                                ) : (
                                  <StopCircleIcon />
                                )
                              }
                              label={
                                customer.system_status === 1
                                  ? "تعمل"
                                  : customer.system_status === 0
                                  ? "متوقفة"
                                  : "-"
                              }
                              color={
                                customer.system_status === 1
                                  ? "success"
                                  : "error"
                              }
                              size="small"
                              sx={{ fontWeight: "bold" }}
                            />
                          </TableCell>
                          <TableCell>
                            <Chip
                              label={
                                customer.tenant?.is_demo === 1 ? "نعم" : "لا"
                              }
                              color={
                                customer.tenant?.is_demo === 1
                                  ? "warning"
                                  : "default"
                              }
                              size="small"
                              variant="outlined"
                            />
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <LocalOfferIcon sx={{ color: "#666", fontSize: 18 }} />
                              {customer.tenant?.plane_id ? (
                                <Box>
                                  <Typography
                                    variant="body2"
                                    sx={{ fontWeight: "bold" }}
                                  >
                                    {planesMap?.[customer.tenant.plane_id] ||
                                      `#${customer.tenant.plane_id}`}
                                  </Typography>
                                  {planesMap?.[customer.tenant.plane_id] && (
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      ID: {customer.tenant.plane_id}
                                    </Typography>
                                  )}
                                </Box>
                              ) : (
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  غير محدد
                                </Typography>
                              )}
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <EventIcon sx={{ color: "#666", fontSize: 18 }} />
                              <Typography variant="body2">
                                {customer.tenant?.start_date
                                  ? new Date(
                                      customer.tenant.start_date
                                    ).toLocaleDateString("EG")
                                  : "-"}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                              }}
                            >
                              <EventIcon sx={{ color: "#666", fontSize: 18 }} />
                              <Typography variant="body2">
                                {customer.tenant?.end_date
                                  ? new Date(customer.tenant.end_date).toLocaleDateString(
                                      "EG"
                                    )
                                  : "-"}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Chip
                              icon={
                                customer.active === 1 ? (
                                  <CheckCircleIcon />
                                ) : (
                                  <ErrorOutlineIcon />
                                )
                              }
                              label={
                                customer.active === 1 ? "نشط" : "غير نشط"
                              }
                              color={
                                customer.active === 1 ? "success" : "error"
                              }
                              size="small"
                              sx={{ fontWeight: "bold" }}
                            />
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 0.5,
                                flexWrap: "wrap",
                              }}
                            >
                              <Tooltip title="عرض التفاصيل">
                                <IconButton
                                  color="info"
                                  size="small"
                                  onClick={() => setViewCustomer(customer)}
                                  sx={{
                                    bgcolor: "#e3f2fd",
                                    "&:hover": { bgcolor: "#bbdefb" },
                                  }}
                                >
                                  <VisibilityIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>

                              {customer.tenant?.id && (
                                <>
                                  <Tooltip title="إرسال تنبيه">
                                    <IconButton
                                      color="warning"
                                      size="small"
                                      onClick={() =>
                                        handleOpenNotifDialog(customer)
                                      }
                                      sx={{
                                        bgcolor: "#fff3e0",
                                        "&:hover": { bgcolor: "#ffe0b2" },
                                      }}
                                    >
                                      <span role="img" aria-label="تنبيه">
                                        🔔
                                      </span>
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title="عرض التنبيهات">
                                    <IconButton
                                      color="primary"
                                      size="small"
                                      onClick={() =>
                                        setShowNotificationsDialog({
                                          open: true,
                                          tenant: customer.tenant?.id || "",
                                        })
                                      }
                                      sx={{
                                        bgcolor: "#e8f5e9",
                                        "&:hover": { bgcolor: "#c8e6c9" },
                                      }}
                                    >
                                      <NotificationsIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Box
                sx={{
                  textAlign: "center",
                  py: 8,
                  bgcolor: "#f5f5f5",
                  borderRadius: 2,
                }}
              >
                <PeopleIcon sx={{ fontSize: 80, color: "#bdbdbd", mb: 2 }} />
                <Typography variant="h6" color="text.secondary">
                  لا توجد عملاء مشتركين
                </Typography>
              </Box>
            )
          ) : activeTab === 1 ? (
            <NonSubscriberSustomersTap />
          ) : (
            /* Tab index 2 -> New requests */
            <NewVersionRequestTap />
          )}
        </Box>
      </Card>

      {/* Dialog لعرض تفاصيل العميل */}
      <Dialog
        open={!!viewCustomer}
        onClose={() => setViewCustomer(null)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 2 },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#667eea",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Avatar
              sx={{
                bgcolor: "white",
                color: "#667eea",
                width: 40,
                height: 40,
              }}
            >
              <PersonIcon />
            </Avatar>
            تفاصيل العميل
          </Box>
          <IconButton
            onClick={() => setViewCustomer(null)}
            sx={{
              color: "white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          {viewCustomer && (
            <Box>
              <Card variant="outlined" sx={{ mb: 2, bgcolor: "#f5f5f5" }}>
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 2,
                      fontWeight: "bold",
                      color: "#667eea",
                    }}
                  >
                    معلومات العميل
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1.5,
                    }}
                  >
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <PersonIcon sx={{ color: "#667eea" }} />
                      <Typography>
                        <b>الاسم:</b> {viewCustomer.name}
                      </Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <EmailIcon sx={{ color: "#667eea" }} />
                      <Typography>
                        <b>البريد الإلكتروني:</b> {viewCustomer.email}
                      </Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <PhoneIcon sx={{ color: "#667eea" }} />
                      <Typography>
                        <b>رقم الجوال:</b> {viewCustomer.phone}
                      </Typography>
                    </Box>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <CheckCircleIcon
                        sx={{
                          color: viewCustomer.active === 1 ? "#4caf50" : "#f44336",
                        }}
                      />
                      <Typography>
                        <b>الحالة:</b>
                      </Typography>
                      <Chip
                        label={
                          viewCustomer.active === 1 ? "نشط" : "غير نشط"
                        }
                        color={
                          viewCustomer.active === 1 ? "success" : "error"
                        }
                        size="small"
                      />
                    </Box>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <LanguageIcon sx={{ color: "#667eea" }} />
                      <Typography>
                        <b>الدومين:</b>
                      </Typography>
                      <Chip
                        label={
                          viewCustomer.tenant?.domains?.[0]?.domain || "-"
                        }
                        color="info"
                        size="small"
                        sx={{
                          maxWidth: "100%",
                          "& .MuiChip-label": {
                            display: "block",
                            whiteSpace: "normal",
                            wordBreak: "break-all",
                          },
                        }}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>

              {viewCustomer.tenant && (
                <Card variant="outlined">
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{
                        mb: 2,
                        fontWeight: "bold",
                        color: "#667eea",
                      }}
                    >
                      بيانات التينانت
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <TableContainer component={Paper} elevation={0}>
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                            <TableCell sx={{ fontWeight: "bold" }}>نسخ احتياطي</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>تجريبي</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>رقم الباقة</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>تاريخ البداية</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>تاريخ النهاية</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>{viewCustomer.tenant.database_backup}</TableCell>
                            <TableCell>
                              <Chip
                                label={
                                  viewCustomer.tenant.is_demo === 1 ? "نعم" : "لا"
                                }
                                color={
                                  viewCustomer.tenant.is_demo === 1
                                    ? "warning"
                                    : "default"
                                }
                                size="small"
                              />
                            </TableCell>
                            <TableCell>{viewCustomer.tenant.plane_id || "غير محدد"}</TableCell>
                            <TableCell>{viewCustomer.tenant.start_date || "غير محدد"}</TableCell>
                            <TableCell>{viewCustomer.tenant.end_date || "غير محدد"}</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ p: 2.5, bgcolor: "#f5f5f5" }}>
          <Button
            onClick={() => setViewCustomer(null)}
            variant="contained"
            size="large"
            sx={{ minWidth: 100 }}
          >
            إغلاق
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog تأكيد حذف الفيتشر */}
      <Dialog
        open={confirmDelete.open}
        onClose={() =>
          setConfirmDelete({
            open: false,
            tenantId: null,
            featureId: null,
            featureName: "",
          })
        }
      >
        <DialogTitle>تأكيد الحذف</DialogTitle>
        <DialogContent>
          <Typography>
            هل أنت متأكد أنك تريد حذف الفيتشر{" "}
            <b>{confirmDelete.featureName}</b> من التينانت؟
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setConfirmDelete({
                open: false,
                tenantId: null,
                featureId: null,
                featureName: "",
              })
            }
          >
            إلغاء
          </Button>
          <Button color="error" onClick={confirmDeleteFeature}>
            تأكيد الحذف
          </Button>
        </DialogActions>
      </Dialog>

      <SendNotificationDialog
        open={notifDialog.open}
        onClose={() => setNotifDialog({ open: false, tenant: null })}
        tenant={notifDialog.tenant}
        onSuccess={handleNotifSuccess}
      />

      {/* Snackbar notifications */}
      <Snackbar
        open={!!notifMsg}
        autoHideDuration={3000}
        onClose={() => setNotifMsg("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setNotifMsg("")}
          severity="success"
          sx={{ width: "100%" }}
        >
          {notifMsg}
        </Alert>
      </Snackbar>
      <Snackbar
        open={!!notifError}
        autoHideDuration={3000}
        onClose={() => setNotifError("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setNotifError("")}
          severity="error"
          sx={{ width: "100%" }}
        >
          {notifError}
        </Alert>
      </Snackbar>

      {/* Dialog عرض التنبيهات */}
      <Dialog
        open={showNotificationsDialog.open}
        onClose={() =>
          setShowNotificationsDialog({ open: false, tenant: null })
        }
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>عرض التنبيهات</DialogTitle>
        <DialogContent>
          {/* تمرير tenantId لمكون ShowClintNotification */}
          <ShowClintNotification tenantId={showNotificationsDialog.tenant} />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() =>
              setShowNotificationsDialog({ open: false, tenant: null })
            }
          >
            إغلاق
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog لتأكيد تفعيل النسخة بدلاً من استخدام confirm() */}
      <Dialog
        open={activateDialog.open}
        onClose={cancelActivate}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>تأكيد تفعيل النسخة</DialogTitle>
        <DialogContent>
          <Typography>
            {activateDialog.tenantId ? (
              <>
                هل أنت متأكد أنك تريد تفعيل نسخة للتينانت رقم:{" "}
                <b>{activateDialog.tenantId}</b>؟
              </>
            ) : (
              <>
                لا يوجد تينانت مرتبط — سيتم تفعيل/إنشاء نسخة للعميل رقم:{" "}
                <b>{activateDialog.customerId}</b>
              </>
            )}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelActivate}>إلغاء</Button>
          <Button
            color="primary"
            onClick={performActivateCopy}
            disabled={
              !(activateDialog.tenantId || activateDialog.customerId) ||
              activating.includes(activateDialog.key)
            }
          >
            {activating.includes(activateDialog.key)
              ? "جاري التفعيل..."
              : "تأكيد التفعيل"}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CustomerPageMain;
